import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import styles from './styles.module.css';
import Api from '@/api';
import NearByStores from './NearByStores';
import Select from '@/components/common/Select';
import getMoreList from '@/functions/getMoreList';
import mockData from '@/mock/address.json';
import { address, position, setState } from '@/commonTypes';
import { usePathname, useSearchParams } from 'next/navigation';

const AppMap = dynamic(() => import('@/components/general/AppMap'), {
  ssr: false,
  loading: () => <div style={{ height: '600px', width: '100%' }} />, // یا هر placeholder دلخواه
});

export default function ShopsMap({
  position,
  setPosition,
  addresses,
  setAddresses,
}: {
  position: position;
  setPosition: setState<position>;
  addresses: address[];
  setAddresses: setState<address[]>;
}) {
  const [allFeatures, setAllFeatures] = useState<address[]>([]);

  const [features, setFeatures] = useState<address[]>([]);
  const [count, setCount] = useState<string | number | undefined>(0);
  const sampleImage = '/imgs/sample/featmain2.svg';
  const [filters, setFilters] = useState([]);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  function generateRandomLocations(center = [35.747288, 51.303524], count = 200, radiusInKm = 10) {
    const locations = [];
    const [centerLat, centerLng] = center;

    for (let i = 0; i < count; i++) {
      // Generate random distance (0 to radius)
      const radius = Math.random() * radiusInKm;

      // Convert radius to degrees (rough approximation)
      const radiusInDegrees = radius / 111; // 1 deg ~ 111 km

      // Random angle
      const angle = Math.random() * 2 * Math.PI;

      // Calculate offset
      const dx = radiusInDegrees * Math.cos(angle);
      const dy = radiusInDegrees * Math.sin(angle);

      const lat = centerLat + dx;
      const lng = centerLng + dy;

      // Create fake name and address
      const name = `Location ${i + 1}`;
      const slug = `shop_${i + 1}`;

      const address = `Fake Address ${i + 1}`;

      locations.push({
        name,
        address,
        location: {
          latitude: lat.toFixed(6),
          longitude: lng.toFixed(6),
        },
        slug,
      });
    }

    return locations;
  }

  useEffect(() => {
    //   let filterParams = {
    //     isServiceReq: undefined,
    //     carModelId: undefined,
    //     brandIds: undefined,
    //     productId: undefined,
    //     serviceIds: undefined,
    //     minPrice: undefined,
    //     maxPrice: undefined,
    //     ...filters?.filter?.params,
    //   };
    //   if (filters) {
    //     filterParams = {
    //       isServiceReq: filters?.isServiceReq,
    //       carModelId: filters?.models?.[0]?.id,
    //       // brandId:filters?.brands?.[0]?.id,
    //       brandIds: filters?.brands?.map((d: any) => d?.id),
    //       productId: filters?.products?.map((d: any) => d?.id),
    //       serviceIds: filters?.services?.map((d: any) => d?.id),
    //       minPrice: filters?.minPrice,
    //       maxPrice: filters?.maxPrice,
    //       ...filters?.filter?.params,
    //     };
    //   }
    let filterParams = {};
    if (pathname?.includes('/shop-services')) {
      filterParams = { ...filterParams, isServiceReq: true };
    }
    const queryObject = Object.fromEntries(searchParams.entries());

    if (queryObject) {
      filterParams = { ...filterParams, ...queryObject };
    }

    console.log('queryObject========', queryObject, searchParams);
    getLocations(true, 0, filterParams);
    getLocations(false, 0, filterParams);
  }, [position, searchParams]);

  //   useEffect(() => {
  //     let filterParams = {
  //       isServiceReq: undefined,
  //       carModelId: undefined,
  //       brandIds: undefined,
  //       productId: undefined,
  //       serviceIds: undefined,
  //       minPrice: undefined,
  //       maxPrice: undefined,
  //       ...filters?.filter?.params,
  //     };
  //     if (filters) {
  //       filterParams = {
  //         isServiceReq: filters?.isServiceReq,
  //         carModelId: filters?.models?.[0]?.id,
  //         // brandId: filters?.brands?.[0]?.id,
  //         brandIds: filters?.brands?.map((d: any) => d?.id),
  //         productId: filters?.products?.map((d: any) => d?.id),
  //         serviceIds: filters?.services?.map((d: any) => d?.id),
  //         minPrice: filters?.minPrice,
  //         maxPrice: filters?.maxPrice,
  //         ...filters?.filter?.params,
  //       };
  //     }
  //     getLocations(true, 0, filterParams);
  //     getLocations(false, 0, filterParams);
  //   }, [filters]);

  const getLocations = (all = true, start = 0, extraParams = {}) => {
    let params = {
      // radius:2000,
      latitude: position[0],
      longitude: position[1],
      start: start,
      limit: 10,
      ...extraParams,
    };
    if (all) {
      params = { ...params, limit: 100 };
    }
    const fakeList: address[] = generateRandomLocations(position, 100, 10);
    setAllFeatures(fakeList);
    // Api.getnearby({ params: params })
    //   .then((res: { data: { response: any; response_details?: { count?: string | number } } }) => {
    //     if (all) {
    //       //   const fakeList = generateRandomLocations(position, 100, 10);
    //       setAllFeatures(res?.data?.response); // ?.concat(fakeList))
    //     } else {
    //       if (start == 0) {
    //         setFeatures(
    //           res?.data?.response?.map((d: any) => {
    //             return {
    //               ...d,
    //               title: d?.name,
    //               image: d?.image?.name ? d?.image?.name : sampleImage,
    //             };
    //           }),
    //         );
    //       } else {
    //         setFeatures(
    //           features?.concat(
    //             res?.data?.response?.map((d: any) => {
    //               return {
    //                 ...d,
    //                 title: d?.name,
    //                 image: d?.image?.name ? d?.image?.name : sampleImage,
    //               };
    //             }),
    //           ),
    //         );
    //       }
    //     }
    //     setCount(res?.data?.response_details?.count);
    //   })
    //   .catch((err: object) => {});
  };
  console.log('allFeatures========', allFeatures);
  return (
    <>
      <div className={`${styles.google_map}`}>
        <AppMap position={position} setPosition={setPosition} list={allFeatures} />
      </div>
      <NearByStores />
    </>
  );
}
